<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()"><ion-icon slot="start" name="close"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title clas="ion-text-center">Passwort Ändern</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
<form id="accountForm" [formGroup]="passwordChangeForm" (ngSubmit)="onChangePassword()" novalidate>
  <ion-list>
    <ion-item>
      <ion-label position="stacked">
        Aktuelles Passwort
      </ion-label>
      <ion-input type="password" autofocus="true" autcomplete="password" inputmode="password" name="current_password" formControlName="current_password"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">
        Neues Passwort
      </ion-label>
      <ion-input type="password" autcomplete="password" name="password" formControlName="password"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">
        Neues Passwort wiederholen
      </ion-label>
      <ion-input type="password" autcomplete="password" name="password2" formControlName="password2"></ion-input>
    </ion-item>
  </ion-list>
  <ion-button type="submit" size="block" [disabled]="!passwordChangeForm.dirty || passwordChangeForm.invalid">Passwort ändern</ion-button>
</form>

</ion-content>
